import { useEffect, useRef, useState } from "react";
import "./styles.css";
import { updateUser } from "../../Login/helpers";
import { withRouter } from "react-router";
import {
    clientErrorMessages,
    EMPTY_STRING,
    MAX_EMAIL_LENGTH,
    SUCCESS,
} from "../../../constants";
import PropTypes from "prop-types";
import AHAlphaField from "../../__shared__/StyleGuide/AHAlphaField";
import { securityFields, securityMessages, securityTitles } from "../constants";
import { updatePassword } from "../helpers";
import { signUpErrorMsgs } from "../../SignUpFlow/constants";
import NewPassword from "../../__shared__/StyleGuide/NewPassword";
import {
    messages,
    viewType,
} from "../../__shared__/StyleGuide/NewPassword/constants";
import DecisionAlertCard from "../../__shared__/DecisionAlertCard";
import { isEmpty } from "../../../helpers/helpers";
import { rootStore } from "../../../redux/store";
import { setErrorState } from "../../../redux/error_banner/actions";
import { setUserData } from "../../Login/actions";
import { connect } from "react-redux";
import Button from "../../../ui/Button";

function Security(props) {
    let timerId = null;

    const { userData, authToken, handleLogout, setUserData } = props;

    const [mfaEnabled, setMFAEnabled] = useState(userData.mfaEnabled);
    const [displayAlert, setDisplayAlert] = useState(false);
    const [currentPassword, setCurrentPassword] = useState(EMPTY_STRING);
    const [errorPasswordMsg, setErrorPasswordMsg] = useState(EMPTY_STRING);
    const [successPasswordMsg, setSuccessPasswordMsg] = useState(EMPTY_STRING);

    const containerRef = useRef(null);

    useEffect(() => {
        timerId = null;
    });

    function handleSetMFA(enable) {
        if (enable) {
            setDisplayAlert(true);
        } else {
            let newUserData = userData;
            newUserData.mfaEnabled = enable;
            updateUser(userData.username, authToken, newUserData)
                .then((payload) => {
                    if (!isEmpty(payload) && payload.status === SUCCESS) {
                        setUserData(newUserData);
                    } else {
                        throw new Error(
                            clientErrorMessages.FAILED_TO_UPDATE_USER
                        );
                    }
                })
                .catch((e) => {
                    rootStore.dispatch(setErrorState(true, String(e)));
                });
            setMFAEnabled(false);
        }
    }

    function handlePasswordChange(label, value) {
        if (label === securityFields.CURRENT_PASSWORD) {
            setCurrentPassword(value);
        }
    }

    function handleSubmit(message, newPassword) {
        setErrorPasswordMsg(EMPTY_STRING);
        setSuccessPasswordMsg(EMPTY_STRING);

        if (message !== messages.SUCCESS) {
            let errorMsg;
            switch (message) {
                case signUpErrorMsgs.EMPTY_PASSWORD: {
                    errorMsg = securityMessages.EMPTY_PASSWORD;
                    break;
                }
                case signUpErrorMsgs.PERSONAL_INFO_PASSWORD: {
                    errorMsg = securityMessages.PERSONAL_INFO_PASSWORD;
                    break;
                }
                case signUpErrorMsgs.COMMON_PASSWORD: {
                    errorMsg = securityMessages.COMMON_PASSWORD;
                    break;
                }
                case signUpErrorMsgs.SHORT_PASSWORD: {
                    errorMsg = securityMessages.SHORT_PASSWORD;
                    break;
                }
                case signUpErrorMsgs.NOT_ENOUGH_CHARACTER_TYPE_PASSWORD: {
                    errorMsg =
                        securityMessages.NOT_ENOUGH_CHARACTER_TYPE_PASSWORD;
                    break;
                }
                default:
                    errorMsg = message;
                    break;
            }
            setErrorPasswordMsg(errorMsg);
        } else {
            updatePassword(
                userData.username,
                currentPassword,
                newPassword,
                authToken
            )
                .then((json) => {
                    if (json) {
                        setSuccessPasswordMsg(securityMessages.SUCCESS);
                        clearInterval(timerId);
                        timerId = setTimeout(() => {
                            handleLogout();
                        }, 2000);
                    } else {
                        setErrorPasswordMsg(
                            securityMessages.WRONG_CURRENT_PASSWORD
                        );
                    }
                })
                .catch((error) => {
                    setErrorPasswordMsg(error.message);
                });
        }
    }

    function displayLogoutAlert() {
        if (displayAlert) {
            return (
                <div>
                    <DecisionAlertCard
                        id={"review-patient-data-alert"}
                        noBtnCallback={() => {
                            setDisplayAlert(false);
                        }}
                        noBtnTxt={"No"}
                        yesBtnTxt={"Yes"}
                        yesBtnCallback={() => {
                            confirmEnableMFAAndLogout();
                        }}
                    >
                        <div
                            className={"review-patient-data-alert-card-header"}
                        >
                            <p className="text-xl">Confirm Logout?</p>
                        </div>
                        <div className={"review-patient-data-alert-card-body"}>
                            <div className={"review-patient-data-alert-row"}>
                                <p>
                                    The next time you log in, you will be
                                    prompted to scan a QR code with your
                                    authenticator app to setup one time passcode
                                    authentication if you have not already done
                                    this before for your account.
                                </p>
                            </div>
                        </div>
                    </DecisionAlertCard>
                    <div id={"review-patient-data-alert-overlay"} />
                </div>
            );
        }
    }

    function confirmEnableMFAAndLogout() {
        let newUserData = userData;
        newUserData.mfaEnabled = true;
        updateUser(userData.username, authToken, newUserData)
            .then((payload) => {
                if (!isEmpty(payload) && payload.status === SUCCESS) {
                    setDisplayAlert(false);
                    handleLogout();
                } else {
                    throw new Error(clientErrorMessages.FAILED_TO_UPDATE_USER);
                }
            })
            .catch((e) => {
                rootStore.dispatch(setErrorState(true, String(e)));
            });
    }

    return (
        <div ref={containerRef} id="security-container" className="grid-cols-3">
            <div className="security-child-container col-span-2">
                <div className="security-child-heading">
                    {securityTitles.CHANGE_PASSWORD}
                </div>
                <div>
                    {errorPasswordMsg ? (
                        <div
                            id="security-change-password-error-msg"
                            className="text-(--errorRed)"
                        >
                            {errorPasswordMsg}
                        </div>
                    ) : (
                        <div
                            id="security-change-password-success-msg"
                            className="text-[#7ed321]"
                        >
                            {successPasswordMsg}
                        </div>
                    )}
                    <table id="security-change-password-table">
                        <tr>
                            <td className="w-2/5">
                                {securityFields.CURRENT_PASSWORD}
                            </td>
                            <td className="w-3/5">
                                <AHAlphaField
                                    label={securityFields.CURRENT_PASSWORD}
                                    value={currentPassword}
                                    placeholder={
                                        securityFields.CURRENT_PASSWORD
                                    }
                                    id="security-current-password"
                                    type={"password"}
                                    maxLength={MAX_EMAIL_LENGTH}
                                    showLabel={false}
                                    onChange={handlePasswordChange}
                                />
                            </td>
                        </tr>
                        <NewPassword
                            viewType={viewType.TABLE_VIEW}
                            currentPassword={currentPassword}
                            userData={userData}
                            onParentSubmit={handleSubmit}
                            newPasswordId={"security-new-password"}
                            confirmPasswordId={"security-confirm-password"}
                            newPasswordPlaceholder={securityFields.NEW_PASSWORD}
                            confirmPasswordPlaceholder={
                                securityFields.PASSWORD_CONFIRMATION
                            }
                        />
                    </table>
                </div>
            </div>
            <div className="security-child-container">
                <div className="security-child-heading">
                    {securityTitles.MFA}
                </div>
                <div>
                    <p>
                        Once enabled, you will be prompted to log out. When you
                        log back in, you will need to scan a QR code with your
                        authenticator app to complete the one-time passcode
                        setup &#40;unless you have already configured this for
                        your account&#41;.
                    </p>
                    <br />
                    <p id="mfa-enabled-status">
                        MFA Enabled for Account:&nbsp;
                        {mfaEnabled ? "Yes" : "No"}
                    </p>
                    <Button
                        className="mt-2"
                        onClick={() => handleSetMFA(!mfaEnabled)}
                        variant={mfaEnabled ? "secondary" : "primary"}
                        text={mfaEnabled ? "Disable MFA" : "Enable MFA"}
                        size="md"
                    />
                </div>
            </div>
            {displayLogoutAlert()}
        </div>
    );
}

Security.propTypes = {
    userData: PropTypes.object,
    authToken: PropTypes.string,
    handleLogout: PropTypes.func,
    setUserData: PropTypes.func,
};

const mapDispatchToProps = function (dispatch) {
    return {
        setUserData: (userData) => dispatch(setUserData(userData)),
    };
};

export default withRouter(connect(null, mapDispatchToProps)(Security));
